import actionFromPromise from 'src/app/redux/utils/actionFromPromise';
import rest from 'src/app/redux/modules/dashboardEmails/rest';

export default {
    fetchDashboardEmailsData: actionFromPromise(rest.fetchDashboardEmailsData),
    fetchDashboardEmailCategoriesSummary: actionFromPromise(rest.fetchDashboardEmailCategoriesSummary),
    exportDashboardEmailCategoriesSummary: actionFromPromise(rest.exportDashboardEmailCategoriesSummary),
};